import { storeManager } from '../../../core/store/store-manager.ts';
import { api } from '../../../core/api/client.ts';
import { prescript } from '../../../core/providers/prescript.ts';
import { Logger } from '../../../core/helpers/logger.ts';
export async function resetPersonaHashEventHandler() {
  try {
    storeManager.removeCookie('SIZEBAY_PERSONA_HASH');
    storeManager.removeCookie('SIZEBAY_SESSION_ID_V4');

    const response = await api.get(`${prescript.baseVrfUrl}api/me/session-id`);
    if (response?.data) {
      storeManager.setCookie({ name: 'SIZEBAY_SESSION_ID_V4', value: response.data });
    }

    const syncEvent = new CustomEvent('fh:sync-recommendation', {
      detail: { permalink: prescript.permalink },
    });
    window.dispatchEvent(syncEvent);
  } catch (error) {
    Logger.error('Error resetting persona hash:', error);
  }
}
